import {useCallback} from 'react';
import type {Media} from 'api/types';
import {deleteMedia} from 'api';
import {useGetTokens} from 'services/auth';

export const useDeleteMedia = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (
      ean: string,
      subType: Media['subType'],
      fileNr: number,
      mock?: boolean,
    ) => {
      return deleteMedia(ean, {subType, fileNr}, getTokens, mock);
    },
    [getTokens],
  );
};
